// Copyright 2016 Sorama B.V.

import { Disposable } from "aurelia-binding";
import { Status } from "datatypes/Status";

export enum ServerStatus {
    Online,
    Offline,
    Unreachable,
}

export abstract class IServerStatusService {
    readonly status: ServerStatus;
    readonly online: Status;

    /**
     * Add a new server status handler
     * @param handler
     */
    public abstract addServerStatusHandler(handler: (status: ServerStatus) => Promise<void> | void): Disposable;

    /**
     * Update the current status directly
     */
    abstract updateStatus(): Promise<ServerStatus>;
}
